import { render, staticRenderFns } from "./creditSummary.vue?vue&type=template&id=85255142&scoped=true&"
import script from "./creditSummary.vue?vue&type=script&lang=js&"
export * from "./creditSummary.vue?vue&type=script&lang=js&"
import style0 from "./creditSummary.vue?vue&type=style&index=0&id=85255142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85255142",
  null
  
)

export default component.exports